import React, { useState } from 'react';
import { Modal, Button, Input, message } from 'antd';
import {
  ModalBody,
  InputLabel,
  Container,
  InputContainer,
  ModalContainer,
  InputRow,
  AdduserSec,
  WarningLabel,
} from './styles';
import { useTranslation, withTranslation } from 'react-i18next';
import { updateTwilioConfig, addTwilioConfig } from '../../utils/services/shortMessageTemplateAPI';
import { SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL } from '../../containers/UserSettingsPage/TranslationValues';

const NAMESPACES = [ 'SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL' ];

const TwilioAccConfigModal = props => {
  const { onCancel, subConfigDetails, number } = props;
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(NAMESPACES);
  const [configDetails, setConfigDetails] = useState({ ...subConfigDetails });
  const [warningText, setWarningText] = useState({
    accountSid: '',
    authToken: '',
  });

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      validateDetails();
    }
  };

  const handleChange = e => {
    const { value, name } = e.target;
    setConfigDetails({ ...configDetails, [name]: value });
    if (value) {
      setWarningText({
        ...warningText,
        [name]: '',
      });
    } else {
      setWarningText({
        ...warningText,
        [name]:
          name === 'accountSid' ? t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.EMPTY_ACCOUNT_SID_ERROR_MESSAGE.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.EMPTY_ACCOUNT_SID_ERROR_MESSAGE.value) : t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.EMPTY_AUTH_KEY_ERROR_MESSAGE.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.EMPTY_AUTH_KEY_ERROR_MESSAGE.value),
      });
    }
  };

  const onSave = async () => {
    setLoading(true);
    let response;
    let numByChannel = {
      fromWhatsApp: number.whatsapp,
      fromSms: number.sms,
      fromCall: number.call,
    };
    let payload = { ...configDetails, ...numByChannel };
    if (configDetails?.id) {
      response = await updateTwilioConfig(payload);
    } else {
      response = await addTwilioConfig(payload);
    }
    if (response) {
      setLoading(false);
      if (response.errors.length === 0) {
        if (response.statusCode === 509) {
          message.success(t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.TWILIO_CONFIG_ADD_SUCCESS.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.TWILIO_CONFIG_ADD_SUCCESS.value));
        } else if (response.statusCode === 511) {
          message.success(t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.TWILIO_CONFIG_UPDATE_SUCCESS.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.TWILIO_CONFIG_UPDATE_SUCCESS.value));
        }
        onCancel();
      }else {
        if (response.statusCode === 510) {
          message.error(t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.TWILIO_CONFIG_ADD_FAILURE.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.TWILIO_CONFIG_ADD_FAILURE.value));
        } else if (response.statusCode === 512) {
          message.error(t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.TWILIO_CONFIG_UPDATE_FAILURE.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.TWILIO_CONFIG_UPDATE_FAILURE.value));
        }
      }
    }
  };

  const validateDetails = async () => {
    if (
      configDetails.accountSid &&
      configDetails.authToken &&
      !warningText.accountSid &&
      !warningText.authToken
    ) {
      onSave();
    } else {
      setWarningText({
        ...warningText,
        authToken: warningText.authToken
          ? warningText.authToken
          : !configDetails.authToken
          ? t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.EMPTY_AUTH_KEY_ERROR_MESSAGE.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.EMPTY_AUTH_KEY_ERROR_MESSAGE.value)
          : '',
        accountSid: warningText.accountSid
          ? warningText.accountSid
          : !configDetails.accountSid
          ? t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.EMPTY_ACCOUNT_SID_ERROR_MESSAGE.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.EMPTY_ACCOUNT_SID_ERROR_MESSAGE.value)
          : '',
      });
    }
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()} onKeyPress={handleKeyPress}>
      <Modal
        title={
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div>{t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL_TITLE.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL_TITLE.value)}</div>
          </div>
        }
        visible={true}
        maskClosable={false}
        width={600}
        centered
        onCancel={onCancel}
        footer={[
          <Button key="Add User" type="primary" loading={loading} onClick={() => validateDetails()}>
            {configDetails?.id
              ? loading
                ? t(
                    SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.UPDATING_SHORT_MESSAGE_ACCOUNT_TEXT.key,
                    SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.UPDATING_SHORT_MESSAGE_ACCOUNT_TEXT.value,
                  )
                : t(
                    SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.UPDATE_SHORT_MESSAGE_ACCOUNT_BUTTON.key,
                    SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.UPDATE_SHORT_MESSAGE_ACCOUNT_BUTTON.value,
                  )
              : loading
              ? t(
                SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.ADDING_SHORT_MESSAGE_ACCOUNT_TEXT.key,
                SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.ADDING_SHORT_MESSAGE_ACCOUNT_TEXT.value,
              )
              : t(
                SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.ADD_SHORT_MESSAGE_ACCOUNT_BUTTON.key,
                SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.ADD_SHORT_MESSAGE_ACCOUNT_BUTTON.value,
              )}
          </Button>,
        ]}
      >
        <ModalBody>
          <AdduserSec style={{ width: '100%' }}>
            <ModalContainer user={1}>
              <InputRow>
                <InputContainer className="full-width" user={1}>
                  <InputLabel>{t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.AUTH_KEY_LABEL.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.AUTH_KEY_LABEL.value)}</InputLabel>
                  <Input
                    size="large"
                    placeholder={t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.AUTH_KEY_PLACEHOLDER.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.AUTH_KEY_PLACEHOLDER.value)}
                    name="authToken"
                    onChange={handleChange}
                    autoComplete={'off'}
                    value={configDetails.authToken}
                  />
                  <WarningLabel>{warningText.authToken}</WarningLabel>
                </InputContainer>
              </InputRow>
              <InputRow>
                <InputContainer className="full-width" user={1}>
                  <InputLabel>{t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.ACC_SID_LABEL.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.ACC_SID_LABEL.value)}</InputLabel>
                  <Input
                    size="large"
                    placeholder={t(SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.ACC_SID_PLACEHOLDER.key, SHORT_MESSAGE_ACCOUNT_CONFIG_MODAL.ACC_SID_PLACEHOLDER.value)}
                    name="accountSid"
                    onChange={handleChange}
                    autoComplete={'off'}
                    value={configDetails.accountSid}
                  />
                  <WarningLabel>{warningText.accountSid} </WarningLabel>
                </InputContainer>
              </InputRow>
            </ModalContainer>
          </AdduserSec>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default withTranslation(NAMESPACES)(TwilioAccConfigModal);
